import * as types from './mutation_types'

export default {
  [types.ACCOUNT_SETTLEMENT_CONTINUATION_RESET] (state) {
    Object.assign(state, {
      error: '',
      isLoading: false,
      items: [],
      view: []
    })
  },

  [types.ACCOUNT_SETTLEMENT_CONTINUATION_SET_ERROR] (state, error) {
    Object.assign(state, { error })
  },

  [types.ACCOUNT_SETTLEMENT_CONTINUATION_SET_ITEMS] (state, items) {
    Object.assign(state, {
      error: '',
      items
    })
  },

  [types.ACCOUNT_SETTLEMENT_CONTINUATION_TOGGLE_LOADING] (state) {
    Object.assign(state, { isLoading: !state.isLoading })
  },

  [types.ACCOUNT_SETTLEMENT_CONTINUATION_SET_VIEW] (state, view) {
    Object.assign(state, { view })
  }
}
